import React, {
  useState,
  useEffect,
  forwardRef,
  useRef,
  useImperativeHandle,
} from "react";
import {
  Card
} from "@veneer/core";
import { Container, Row, Col } from "react-bootstrap";
import { useAppSelector, useAppDispatch } from '@store/hooks';
import type { RootState } from '@store/store';
import { clearContactDetails } from '@store/reducers/fetch-contact-details-info-apis';
import PhysicalAddressFields from './equipment-physical-address-fields/equipment-physical-address-fields';
import NewShippingAddress from "./new-shipping-address/new-shipping-address";
import PartsShippingAddressFields from "./parts-shipping-address-fields/parts-shipping-address-fields";
import {Trans,useTranslation} from 'react-i18next';
import CustomerAvailability from "./customer-availability/customer-availability";
import './case-address.css';

interface CaseAddressRef {
  submitForm: () => boolean;
}
interface CaseAddressProps {
  onAddressValidationChange?: (isValidated: boolean, contryEnable: boolean) => void;
  productInfo: any;
  onCustomerAvailabilityChange?: (
    data: any,
    isValid: boolean
  ) => void;
}
const CaseAddress = forwardRef<CaseAddressRef, CaseAddressProps>(
  ({ onAddressValidationChange, onCustomerAvailabilityChange, productInfo }, ref) => {

  const { t } = useTranslation();
  const casePhysicalAddressChildRef = useRef<CaseAddressRef>(null);
  const casePartAddressChildRef = useRef<CaseAddressRef>(null);
  const customerAvailabilityRef = useRef<CaseAddressRef>(null);
  const [isShow, setIsShow] = useState<boolean>(false);
  const [newEquipmentContact, setNewEquipmentContact] = useState<boolean>(false);

  const content2 = t("HPI.CreateCase.Shippingaddress.addressnote",{defaultValue:'Please include the contact and address information where parts should be shipped.'})
  // const content1 = t('HPI.CreateCase.EquipmentAddress.addressnote',{defaultValue:`Please verify the physical address where the equipment related to the case is located. By default, the contact information is automatically filled with the Primary contact information while the address information is automatically filled with the Site or Company address. To use a completely new contact, select the “create a new contact” value in the pull-down, and do not edit an existing contact’s information. Any changes made within this form are effective for this case only.\r\n`})
  const content1 = t('HPI.CreateCase.EquipmentAddress.addressnote',{defaultValue:`Please provide the contact details of the person responsible for coordinating the delivery, repair, or  drop-off of the equipment/product.\r\n`})

  const { contactDetails } = useAppSelector((state: RootState) => state.fetchContactDetailsInfoAPI);
  const { formShippingAddressData } = useAppSelector((state: RootState) => state.formShippingAddressInfo);
  const isEquipmentContactSelected: boolean = formShippingAddressData?.isEquipmentContactSelected ?? false;

  const dispatch = useAppDispatch();


  useEffect(() => {
    if (contactDetails) {
      dispatch(clearContactDetails());
    }
  }, [contactDetails])


  const onShippingHandler = (isOn:any) => {
    setIsShow(isOn)
  }

  useImperativeHandle(ref, () => ({
    submitForm: () => {
      let isPhysicalValid = casePhysicalAddressChildRef.current?.submitForm() ?? false;
      let isPartValid =isShow? casePartAddressChildRef.current?.submitForm() ?? false : true;
      let isCustomerAvailabilityValid =
          (shouldShowCustomerAvailability && (newEquipmentContact || isEquipmentContactSelected))
          ? customerAvailabilityRef.current?.submitForm() ?? false
          : true;
      return isPhysicalValid && isPartValid && isCustomerAvailabilityValid;

    }
  }));

  const shouldShowCustomerAvailability = (() => {
    const storedValue = sessionStorage.getItem("isCustomerAvailability");
    const isPoly = sessionStorage.getItem("isPoly");
    const isPolyAllowed = isPoly === null || isPoly === "false";
    if (storedValue !== null) {
      return storedValue === "true" && isPolyAllowed;
    }

    let resolvedValue = false;
    try {
      resolvedValue =
        productInfo?.customerAvailabilityDetails != null &&
        Number(JSON.parse(productInfo.customerAvailabilityDetails)?.IsApplicable) !== -1;
    } catch {
      resolvedValue = false;
    }

    sessionStorage.setItem("isCustomerAvailability", String(resolvedValue));

    return resolvedValue && isPolyAllowed;
  })();

  return (
    <Container fluid className="contact-info-container">
      {/* <Card
        className="card-contact-containerr"
        content={<> */}
          <PhysicalAddressFields
            ref={casePhysicalAddressChildRef}
            headerTitle={t("HPI.CreateCase.address.equipmentcontactdetails",{defaultValue:'Equipment contact details'})}
            headerContent={content1}
              onValidationChange={(isValidated, contryEnable) => {
              if (onAddressValidationChange) {
              onAddressValidationChange(isValidated, contryEnable);
                }
              }}
            onNewEquipmentContactChange={(isNew) => setNewEquipmentContact(isNew)}
            checkBoxContent={t('HPI.CreateCase.HPAcknowledge',{defaultValue:'By checking this box, I acknowledge HP is not responsible for the loss of data, programs, or my confidential, personal, or proprietary information contained in storage media on the device being shipped.'})}
            />
        {/* </>}
      /> */}
      {/* </Card> */}

       <Card
        className="card-contact p-4"
        content={<> 
          <NewShippingAddress
            title={t("HPI.CreateCase.address.partshippingaddress",{defaultValue:'Parts Shipping Address'})}
            subContent={content2}
            onchange={onShippingHandler}
          />
         </>
         }
      />
         {isShow && <>
           <PartsShippingAddressFields ref={casePartAddressChildRef} /></>}
            {(shouldShowCustomerAvailability && (newEquipmentContact || isEquipmentContactSelected)) && (
          <Card
           className="card-contacts p-4"
           content={<>
           <CustomerAvailability
                ref = {customerAvailabilityRef}
                productInfo={productInfo}
                onFormChange={(data: any, isValid: boolean) => {
                  onCustomerAvailabilityChange?.(data, isValid);
                }}
              />
           </>}
            /> 
              )}
    </Container>
  );
});

export default CaseAddress;